import { Box, Button, Divider, Flex, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../features/auth/AuthProvider';
import SidebarBrand from './Brand';
import SidebarLinks from './Links';
import type { RouteItem } from '../Sidebar';

interface SidebarContentProps {
  routes: RouteItem[];
  onClose?: () => void;
}

export function SidebarContent({ routes, onClose }: SidebarContentProps) {
  const { t } = useTranslation();
  const { admin, signOut } = useAuth();
  const textColor = useColorModeValue('navy.700', 'white');

  return (
    <Flex direction="column" height="100%" pt="25px" borderRadius="30px">
      <SidebarBrand />
      <Stack direction="column" mb="auto" mt="8px">
        <Box ps="20px" pe={{ md: '16px', '2xl': '1px' }}>
          <SidebarLinks routes={routes} onClose={onClose} />
        </Box>
      </Stack>

      <Box pl={4} pr={6} pb={6} pt={4}>
        <Divider mb={4} />
        <Text
          fontSize="xs"
          color={textColor}
          fontWeight="600"
          data-testid="sidebar-user-email"
        >
          {admin?.email}
        </Text>
        <Text fontSize="xs" color="secondaryGray.600" textTransform="capitalize" mb={2}>
          {admin?.role}
        </Text>
        <Button
          size="sm"
          w="100%"
          onClick={signOut}
          data-testid="btn-sign-out"
          variant="solid"
          bg="red.500"
          color="white"
          _hover={{ bg: 'red.600' }}
          _active={{ bg: 'red.700' }}
        >
          {t('admin.nav.signOut')}
        </Button>
      </Box>
    </Flex>
  );
}

export default SidebarContent;
